interface Props {
  value: number;
}

export function CarHealthGauge({ value }: Props) {
  const radius = 55;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (value / 100) * circumference;

  const getColor = () => {
    if (value >= 80) return "text-green-500 stroke-green-500";
    if (value >= 60) return "text-yellow-500 stroke-yellow-500";
    if (value >= 40) return "text-orange-500 stroke-orange-500";
    return "text-red-500 stroke-red-500";
  };

  return (
    <div className="w-full bg-primaryBg text-primaryText dark:text-primaryTextDark dark:bg-primaryBgDark rounded-xl shadow p-4 flex flex-col items-center">
      <h2 className="text-lg font-semibold mb-1">Car Health</h2>

      <div className="relative flex items-center justify-center">
        <svg width="160" height="160" className="rotate-[-90deg]">
          <circle
            cx="80"
            cy="80"
            r={radius}
            stroke="#e5e7eb"
            strokeWidth="10"
            fill="none"
          />

          <circle
            cx="80"
            cy="80"
            r={radius}
            strokeWidth="10"
            className={`${getColor()} transition-all duration-500`}
            fill="none"
            strokeDasharray={circumference}
            strokeDashoffset={offset}
            strokeLinecap="round"
          />
        </svg>

        <div className="absolute flex flex-col items-center">
          <span className={`text-3xl font-bold ${getColor()}`}>{value}</span>
          <span className="text-gray-500 text-sm">%</span>
        </div>
      </div>

      <p className="mt-2 text-sm font-medium">
        {value >= 80
          ? "Excellent"
          : value >= 60
          ? "Good"
          : value >= 40
          ? "Attention"
          : "Poor"}
      </p>
    </div>
  );
}
